import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const trackingBase = (src) =>
  src?.tracking_domain
    ? `https://${src.tracking_domain.replace(/^https?:\/\//, "").replace(/\/+$/, "")}`
    : BACKEND_URL;

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;
